import { Squares2X2Icon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import CategoryList from "./CategoryList"
import AddUpdateCollection from './AddUpdate'
import RouteKeys from "constants/route-keys"

const _routes: RouteElement[] = [

    {
        route: '',
        title: 'Category',
        component: CategoryList,
        icon: Squares2X2Icon,
        key: RouteKeys.CATEGORY,
        display: true
    },
    {
        route: '/update/:id',
        component: AddUpdateCollection,
        title: 'Update Category',
        key: RouteKeys.CATEGORY,
        icon: Squares2X2Icon
    },
    {
        route: '/add',
        component: AddUpdateCollection,
        title: 'Add Category',
        key: RouteKeys.CATEGORY,
        icon: Squares2X2Icon
    },
]

const CategoryManagment = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {
                        _routes.map((route, index) => (
                            <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default CategoryManagment

